import React from 'react'
import {ConfirmContent} from '../../Molecules/BaseContentBlocks/ConfirmContent'
import {PIMStack} from '../../Atoms/Layouts/Bases/PIMStack'
import {MBContentBodyDivider} from '../../Atoms/Dividers'

export type MemberNameConfirmsProps = {
  familyName: string
  firstName: string
  familyNameKana: string
  firstNameKana: string
}
export const MemberNameConfirms: React.VFC<MemberNameConfirmsProps> = (
  {
    familyName,
    firstName,
    familyNameKana,
    firstNameKana,
  },
) => {
  return (
    <PIMStack
      spacing={'18px'}
      divider={<MBContentBodyDivider/>}
    >
      <ConfirmContent
        label={'お名前'} values={[`${familyName} ${firstName}`]}
        testDataId={'confirm-content-full-name'}
      />
      <ConfirmContent
        label={'フリガナ'} values={[familyNameKana + ' ' + firstNameKana]}
        testDataId={'confirm-content-full-name-kana'}
      />
    </PIMStack>
  )
}
